import TableRow from "@mui/material/TableRow";
import { Box, styled, useTheme } from "@mui/material";

import React, { useState } from "react";
import { ChevronRight } from "@mui/icons-material";
import { Paragraph } from "./Typography";
import { dateFormat, formatMoney } from "../../../common/utils";
import DefaultImage from "../images/default-merchant-image.png";
import { LiTableCell } from "./pieces";
import { Purchase } from "../../../types";

interface TableRowMobileProps {
    purchase: Purchase;
    onClick: (event: React.MouseEvent) => void;
}

const TableRowMobile = (props: TableRowMobileProps) => {
    const { purchase, onClick } = props;
    const [errorImg, setErrorImg] = useState<string | undefined>();
    const theme = useTheme();
    const MobilePara = styled(Paragraph)(() => ({
        fontSize: `15px`,
    }));

    return (
        <TableRow
            selected={false}
            sx={{
                "-webkit-tap-highlight-color": `transparent`,
                border: `none`,
                borderTop: `1px solid #E1E1E1`,
                cursor: `pointer`,
            }}
        >
            <LiTableCell sx={{ padding: `16px`, display: `flex` }}>
                <Box
                    onError={() => {
                        setErrorImg(DefaultImage);
                    }}
                    mr="15px"
                    sx={{
                        alignSelf: `center`,
                        maxHeight: 30,
                        height: `auto`,
                        maxWidth: 30,
                        width: `auto`,
                    }}
                    component="img"
                    src={
                        errorImg ||
                        purchase.icon ||
                        `https://s3.amazonaws.com/retailerimages/icon/${purchase.storeGuid}`
                    }
                />
                <Box>
                    <MobilePara sx={{ margin: 0, fontSize: 12 }}>{dateFormat(purchase.date)}</MobilePara>
                    <MobilePara
                        fontWeight={600}
                        sx={{
                            margin: 0,
                            paddingTop: `5px`,
                        }}
                    >
                        {purchase.store}
                    </MobilePara>
                </Box>
            </LiTableCell>
            <LiTableCell sx={{ padding: `16px`, textAlign: `right`, minWidth: 130 }}>
                <Box sx={{ display: `inline-block`, verticalAlign: `middle` }}>
                    <MobilePara
                        sx={{
                            margin: 0,
                            color: `#333`,

                            fontSize: 12,
                        }}
                    >
                        {purchase.status}
                    </MobilePara>
                    <MobilePara sx={{ margin: 0, paddingTop: `5px`, fontWeight: 600 }}>
                        {formatMoney(purchase.cashback)}
                    </MobilePara>
                </Box>
                <ChevronRight
                    onClick={onClick}
                    sx={{ verticalAlign: `bottom`, height: 30, width: 40, color: theme.palette.account.accent }}
                />
            </LiTableCell>
        </TableRow>
    );
};

export default TableRowMobile;
